const state = {
    wordList: '',
}

const mutations = {
    SET_WORDLISTS(state, wordList) {
        state.wordList = wordList
    },
}

const actions = {
    setvmWordList: ({ commit }, wordList) => {
        commit('SET_WORDLISTS', wordList)
    },
}

const getters = {
    vmMainWordList: (state) => {
        return state.wordList.main_list
    },
    vmDistractionWordList: (state) => {
        return state.wordList.distraction_list
    },
    vmRecognitionWordList: (state) => {
        return state.wordList.recognition_list
    },
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/vm.js